import { render, staticRenderFns } from "./tabbar5.vue?vue&type=template&id=1854f53e&scoped=true&"
import script from "./tabbar5.vue?vue&type=script&lang=js&"
export * from "./tabbar5.vue?vue&type=script&lang=js&"
import style0 from "./tabbar5.vue?vue&type=style&index=0&id=1854f53e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854f53e",
  null
  
)

export default component.exports